/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import showFullOptions from './showFullOptions';
import confirmDirtyOptionsAndPerformAction from './confirmDirtyOptionsAndPerformAction';
export default orchestratorAction('navigateToSearchSuggestion', function navigateToSearchSuggestion(category, subcategory, option) {
    var continueAfterConfirmCallback = function () {
        showFullOptions(category, subcategory, option);
    };
    confirmDirtyOptionsAndPerformAction(continueAfterConfirmCallback);
});
//# sourceMappingURL=navigateToSearchSuggestion.js.map